import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Commands from './pages/Commands';
import Guide from './pages/Guide';
import Admin from './pages/Admin';
import Secrets from './pages/Secrets';
import Terms from './pages/Terms';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/GlobalStyles';
import { AuthProvider } from './contexts/AuthContext';

// Importar FontAwesome para los iconos
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

// Añadir iconos a la biblioteca
library.add(fab, fas);

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <Router>
          <GlobalStyles />
          <Header />
          <main>
            <Routes>
              {/* La ruta raíz redirige a secretos */}
              <Route path="/" element={<Navigate to="/secretos" replace />} />
              {/* Ruta para la página de inicio */}
              <Route path="/inicio" element={<Home />} />
              <Route path="/secretos" element={<Secrets />} />
              <Route path="/comandos" element={<Commands />} />
              <Route path="/guia" element={<Guide />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/terminos" element={<Terms />} />
              {/* Redirigir cualquier otra ruta a la página de secretos */}
              <Route path="*" element={<Navigate to="/secretos" replace />} />
            </Routes>
          </main>
          <Footer />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
